import React, { Fragment } from 'react'
import { getStoredItem } from '../../../../../../../../modules/stored-item'
import { namedRoute } from '../../../../../../../../modules/named-router'
import Delimiter from '../Delimiter'
import Icon from '../../../../../../../../components/Icon'
import styled from 'styled-components'
import LinkNavTool from '../LinkNavTool'
import { useUserContext } from '../../../../../../../../components/ContextUser'

const Wrapper = Fragment
const StyledIcon = styled(Icon)`
  font-size: 1.4em;
  color: ${(props) => (props.isUserLoggedIn ? props.theme.color.stol : props.theme.color.secondaryColor)};
`

const StyledHrefLink = styled.a`
  text-decoration: none;
  color: currentColor;
`
const LoginNavTool = ({ ...props }) => {
  const {
    access: { isStandard },
  } = useUserContext()

  return (
    <Wrapper {...props}>
      <Delimiter />
      <LinkNavTool to={!!isStandard ? namedRoute('account').path : namedRoute('login').path}>
        <StyledIcon isUserLoggedIn={!!isStandard} icon="person" />
      </LinkNavTool>
      {getStoredItem('user') !== null && JSON.parse(getStoredItem('user')).roles.includes('backend') && (
        <Fragment>
          <Delimiter />
          <StyledHrefLink href={namedRoute('backend').path}>
            <StyledIcon icon="exit_to_app" />
          </StyledHrefLink>
        </Fragment>
      )}
      <Delimiter />
    </Wrapper>
  )
}

export default LoginNavTool
